import React, { useState, useEffect } from "react";
import { TextField, Button, Grid, Container, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { Box } from "@mui/material";
import { redirect, useParams } from "react-router-dom";
import { Get_One_Choose_Fields_From_MongoDB } from "../../api/Get_One_Choose_Fields_From_MongoDB";
import { Post_To_MongoDB } from "../../api/Post_To_MongoDB";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search";
import { Post_Bursary_To_MongoDB } from "./api/Post_Bursary_To_MongoDB";
import { Get_All_From_MongoDB } from "../../api/Get_All_From_MongoDB";

const BursaryForm = () => {
  const { id } = useParams();

  const [School, setSchool] = useState({ School_Name: "Searching..." });

  useEffect(() => {
    Get_One_From_MongoDB("Schools", "All_Schools", id, setSchool);
  }, []);

  const [Bursaries, setBursaries] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB_With_Search(
      "Registers_2025",
      "All",
      { "MetaData.Bursary": "Yes" },
      10000,
      setBursaries,
      {
        _id: 1,
        "BasicInfo.School_id": 1,
        "BasicInfo.ProgrammeTitle": 1,
        "BasicInfo.ProgrammeDate": 1,
        "BasicInfo.ProgrammeVarient": 1,
      }
    );
  }, [id]);

  let Arr_ThisSchoolsBursaries = Bursaries.filter(
    (Bursary) => Bursary.BasicInfo.School_id === id
  );

  //"BasicInfo.School_id": id

  let IntroText = (
    <Typography variant="h5" component="h1" gutterBottom>
      Loading...
    </Typography>
  );

  console.log(School);
  console.log("School");

  if (
    Object.keys(School).length === 0 &&
    School.constructor === Object &&
    !School.School_Name
  ) {
    IntroText = (
      <Typography variant="h5" component="h1" gutterBottom>
        Failed to find the School. Please ensure you have copied the link
        correctly. If this issue persists, Please contact the person who sent
        you this link.
      </Typography>
    );
  } else if (
    Object.keys(School).length !== 0 &&
    School.School_Name &&
    School.School_PS !== "Yes"
  ) {
    IntroText = (
      <Typography variant="h5" component="h1" gutterBottom>
        Thank you for your interest in InvestIN’s bursary scheme!
        <br></br>
        <br></br>
        All of our Global Partner Schools are able to apply for fully-funded
        bursaries on all weekend programmes we are running this term. To
        register as a Partner School and find out more information, please email
        us at info@investin.org
        <br></br>
        <br></br>
        We look forward to hearing from you!
      </Typography>
    );
  } else if (
    Object.keys(School).length !== 0 &&
    School.School_Name &&
    School.School_PS &&
    School.School_PS === "Yes" &&
    Number(Arr_ThisSchoolsBursaries.length) > 9
  ) {
    IntroText = (
      <Typography variant="h5" component="h1" gutterBottom>
        You have now reached the maximum number of bursary applications
        allocated for your school this term.
        <br></br> <br></br>
        You will be able to apply for a further 5 fully-funded bursary places in
        the Autumn term of 2025.
        <br></br> <br></br>
        If you have any questions or need assistance, please email us at
        info@investin.org.
        <br></br> <br></br>
        Thank you for your understanding!
      </Typography>
    );
  } else if (
    Object.keys(School).length !== 0 &&
    School.School_Name &&
    School.School_Country &&
    School.School_Country === "UK" &&
    School.School_PS === "Yes"
  ) {
    IntroText = (
      <Typography variant="h5" component="h1" gutterBottom>
        We are delighted to announce applications for our fully-funded bursaries
        are open for the Spring term. Our bursaries cover 100% of the programme
        fee and are available to all eligible students who attend our Partner
        Schools.
        <br></br> <br></br>
        Bursaries are available for{" "}
        <strong>every programme we are running this term in March.</strong> This
        means there are spaces available for both our live online and in-person
        one day programmes. All Partner Schools can apply for up to{" "}
        <strong>5 bursary places this term.</strong>
        <br></br> <br></br>
        In order to qualify for an InvestIN bursary, your student should satisfy
        one or more of the following criteria:
        <br></br>• Currently in receipt of a bursary from the government's{" "}
        <a href="https://www.gov.uk/1619-bursary-fund">16 to 19 bursary fund</a>{" "}
        (or equivalent)
        <br></br>• Currently receive free school meals during secondary
        education or have done so in the past six years
        <br></br>• Have been in care or taken the role of a caregiver at home
        <br></br>• Currently in receipt of financial aid from their school
        <br></br>
        <br></br>
        <strong>
          For safeguarding reasons, students must be between the ages of 15-18
          on the programme start date. We cannot accept applications for
          students outside of this age range.
        </strong>
        <br></br> <br></br>
        You can choose to apply for either our{" "}
        <strong>in-person (London) or live online </strong>
        weekend programmes. Please note, our in-person opportunities are highly
        limited due to venue capacities and therefore will be awarded on a
        <strong> first-come, first-served basis.</strong> Once capacity on our
        in-person programmes has been reached, you will no longer be able to
        apply for these programmes on the application form. You will be able to
        apply for the live online alternative of the programme instead. Unless
        otherwise specified, all our in-person programmes take place at UCL
        London. Any travel costs or accommodation required will need to be
        organised separately.
        <br></br> <br></br>
        <strong>
          If you cannot see the programme your student wishes to attend on the
          form, this will be because the registers for that opportunity have now
          closed. You will be able to apply again for our weekend programmes in
          the Autumn term or we may have a very select number of places
          available for our Summer opportunities, but we expect these to be
          highly competitive. More information about this will be circulated in
          March.
        </strong>
        <br></br> <br></br>
        To submit an application, we will ask you for the student name, their
        email address, their parent/guardian's email address (for safeguarding
        purposes), their year group and confirmation of which eligibility
        criteria they meet. You will see that each programme has multiple dates
        - please select the date that will work best for your student. Both live
        online and in-person programmes run on the same date.
        <br></br> <br></br>
        Applications for the Spring term are open from{" "}
        <strong>Monday 13th January</strong> and will remain open until capacity
        limits are reached for each programme.
        <br></br> <br></br>Applications will be processed weekly and we will
        notify you via email as to whether your students have received an
        in-person or live online place for their chosen career. Please allow two
        weeks from submission before reaching back out.
        <br></br> <br></br>We will also email the student and parent/guardian at
        the contact details you provide with information on their programme. We
        will also send them a short enrolment form for any{" "}
        <strong>in-person weekend programmes.</strong> This is in line with our
        safeguarding policy for 2024/25. The form requests for a parent/guardian
        to fill out important information relating to emergency contacts, and
        any additional information we need know about medication, SEND and
        emotional wellbeing. It is important that this form is completed at
        least four days before the programme start date, failure to do so will
        lead to delays to the start of their programme.
        <br></br> <br></br>If you have any questions, please don't hesitate to
        reach out to us at info@investin.org.
      </Typography>
    );
  } else if (
    Object.keys(School).length !== 0 &&
    School.School_Name &&
    School.School_Country !== "UK" &&
    School.School_PS === "Yes"
  ) {
    IntroText = (
      <Typography variant="h5" component="h1" gutterBottom>
        We are delighted to announce applications for our fully-funded bursaries
        are open for this term. Our bursaries cover 100% of the programme fee
        and are available to eligible students who attend our Partner Schools.
        <br></br> <br></br>
        Bursaries are available for{" "}
        <strong>
          every live online weekend programme we are running this term.
        </strong>{" "}
        Please note these
        <strong>
          {" "}
          programmes will take on place on Sundays in March 11am - 5:30pm UK
          time.
        </strong>{" "}
        All Partner Schools can apply for up to{" "}
        <strong>5 bursary places</strong> this term.
        <br></br>
        <br></br>
        In order to qualify for an InvestIN bursary, your student should satisfy
        one or more of the following criteria:
        <br></br>• Currently in receipt of a bursary or financial aid from the
        government
        <br></br>• Currently in receipt of financial aid from their school
        <br></br>• Have been in care or taken the role of a caregiver at home
        <br></br>
        <br></br>
        <strong>
          For safeguarding reasons, students{" "}
          <u>must be between the ages of 15-18</u>
          on the programme start date. We cannot accept applications for
          students outside of this age range.
        </strong>
        <br></br> <br></br>
        <strong>
          If you cannot see the programme your student wishes to attend on the
          form, this will be because the registers for that opportunity have now
          closed. You will be able to apply again for our weekend programmes in
          the Spring term.
        </strong>
        <br></br> <br></br>
        To submit an application, we will ask you for the student name, their
        email address, their parent/guardian's email address (for safeguarding
        purposes), their year group and confirmation of which eligibility
        criteria they meet.
        <br></br> <br></br>
        Applications for the Autumn term are open from{" "}
        <strong>Monday 13th January</strong> and will remain open until capacity
        limits are reached for each programme.
        <br></br> <br></br>Applications will be processed weekly and we will
        notify you via email as to whether your students have received an
        in-person or live online place for their chosen career. Please allow two
        weeks from submission before reaching back out.
        <br></br> <br></br>We will also email the student and parent/guardian at
        the contact details you provide with information on their programme.
        <br></br> <br></br>If you have any questions, please don't hesitate to
        reach out to us at info@investin.org.
        <br></br> <br></br>
        <strong>
          Please note: This application form is for our Partner Schools outside
          of the UK. If your school is within the UK and you have incorrectly
          received this international form, please email us at
          info@investin.org.
        </strong>
      </Typography>
    );
  }

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    let data = {
      ...Attendee,
      Notes: [
        {
          DateTime: new Date().toISOString(),
          Note: Note,
          Staff_ID: "Attendee",
        },
      ],
      MetaData: {
        Bursary: "Yes",
        Bursary_Reason: "",
        PrimaryStaff: "64f5e1d3a495a296fc8ecb30",
      },
      Contacts: [
        { Person: "Attendee", Email: AttendeeEmail, Active: "Yes" },
        { Person: "Parent", Email: ParentEmail, Active: "Yes" },
        { Person: "Teacher", Email: TeacherEmail, Active: "Yes" },
      ],
    };
    let GSP_Email;
    if (School.School_PD && School.School_PD.length > 5) {
      GSP_Email = School.School_PD;
    } else {
      GSP_Email = "schools@investin.org";
    }
    Post_Bursary_To_MongoDB(
      data,
      "Registers_2025",
      "All",
      setIsSubmitting,
      GSP_Email,
      AttendeeEmail,
      ParentEmail,
      TeacherEmail
    );
    setIsSubmitted(true);
  };

  const [Attendee, setAttendee] = useState({
    //_id: "id",
    BasicInfo: {
      Created_At: new Date().toISOString(),
      First_Name: "",
      Last_Name: "",
      Gender: "",
      Nationality: "",
      DOB: "",
      uncleanSchool: "",
      School_id: id,
      ProgrammeTitle: "",
      ProgrammeDate: "",
      ProgrammeVarient: "",
      ProgrammeAge: "15-18",
    },
    OrderInfo: {
      OriginalOrderPlatform: "",
      OriginalOrderNumber: "",
      LineItemPrice: "",
      LineItemDiscount: "",
      Deposit: "",
      Aiport_Price: "",
      Accom_Meals: "",
      DiscountCode: "",
    },
    Payments: [],
    Contacts: [],
    Notes: [],
    MetaData: {
      Reserved: "Yes",
      Archived: "",
      CreatedBy: "RegistrationFormAnonymous",
      PrimaryStaff: "",
    },
    IPInfo: {},
  });

  const [Note, setNote] = useState("");
  const [AttendeeEmail, setAttendeeEmail] = useState("");
  const [ParentEmail, setParentEmail] = useState("");
  const [TeacherEmail, setTeacherEmail] = useState("");

  // Functions for handling changes in BasicInfo and OrderInfo
  const handleBasicInfoChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: { ...Attendee.BasicInfo, [e.target.name]: e.target.value },
    });
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };
  const handleAttendeeEmailChange = (e) => {
    setAttendeeEmail(e.target.value);
  };
  const handleParentEmailChange = (e) => {
    setParentEmail(e.target.value);
  };
  const handleTeacherEmailChange = (e) => {
    setTeacherEmail(e.target.value);
  };

  const handleProgrammeTitleChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeTitle"]: e.target.value,
        ["ProgrammeDate"]: "",
        ["ProgrammeVarient"]: "",
      },
    });
  };

  const handleProgrammeDateChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeDate"]: e.target.value,
        ["ProgrammeVarient"]: "",
      },
    });
  };

  //Filter Array
  //let ArrAllProgrammesFiltered = ArrAllProgrammes;

  const [data, setdata] = useState([]);
  useEffect(() => {
    Get_All_From_MongoDB("Lookups", "Programmes_2025", setdata);
  }, []);

  //Filter Array
  let ArrAllProgrammesFiltered = data;

  ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
    Varient.Age.includes("15-18")
  );

  ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
    Varient.Type.includes("Weekend")
  );
  function isDateBefore7DaysAfter(dateString) {
    // Define the regular expression to match the date pattern
    const datePattern = /\((\d{1,2}(?:st|nd|rd|th)?\s+\w+\s+\d{4})\)/;

    // Apply the regular expression to extract the date
    const match = dateString.match(datePattern);

    // If a match is found, process the extracted date
    if (match && match[1]) {
      let extractedDate = match[1];

      // Remove the ordinal suffix (st, nd, rd, th) from the day
      extractedDate = extractedDate.replace(/(\d{1,2})(st|nd|rd|th)/, "$1");

      // Convert the extracted date to a Date object
      const dateObject = new Date(extractedDate);

      // Get today's date
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set the time to midnight to compare only the date part

      // Calculate the date that is 7 days after today
      const sevenDaysBeforeToday = new Date(today);
      sevenDaysBeforeToday.setDate(today.getDate() + 7);

      // Return true if the date is after 7 days after today, false otherwise
      return dateObject > sevenDaysBeforeToday;
    }

    // If no match is found, return false or an appropriate value
    return false;
  }

  ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
    isDateBefore7DaysAfter(Varient.Dates)
  );

  //Get Varients
  let ArrAllProgrammesFiltered_VarientsFiltered =
    ArrAllProgrammesFiltered.filter((Varient) => {
      if (Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeTitle"]) {
        return Varient.Title === Attendee.BasicInfo["ProgrammeTitle"];
      } else {
        return true;
      }
    }).filter(
      (Varient) =>
        !Varient.BursaryPlaces ||
        Number(Varient.BursaryPlaces) >
          Bursaries.filter(
            (Bursary) =>
              Bursary.BasicInfo.ProgrammeTitle === Varient.Title &&
              Bursary.BasicInfo.ProgrammeDate === Varient.Dates &&
              Bursary.BasicInfo.ProgrammeVarient === Varient.Varient
          ).length
    );

  let ArrAllProgrammesFiltered_Varients =
    ArrAllProgrammesFiltered_VarientsFiltered.map((Varient) => Varient.Varient);

  if (
    Object.keys(School).length !== 0 &&
    School.School_Name &&
    School.School_Country &&
    School.School_Country !== "UK" &&
    School.School_PS === "Yes"
  ) {
    ArrAllProgrammesFiltered_Varients =
      ArrAllProgrammesFiltered_Varients.filter(
        (Varient) => Varient === "Full Programme: Live Online with no addons"
      );
  }

  ArrAllProgrammesFiltered_Varients = ArrAllProgrammesFiltered_Varients.filter(
    (value, index, self) => self.indexOf(value) === index
  );

  //Get Titles
  let ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered.map(
    (Varient) => Varient.Title
  );

  ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered_Titles.filter(
    (value, index, self) => self.indexOf(value) === index
  );
  //Get Dates
  let ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered.filter(
    (Varient) => {
      if (Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeTitle"]) {
        return Varient.Title === Attendee.BasicInfo["ProgrammeTitle"];
      } else {
        return true;
      }
    }
  );
  ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered_Dates.map(
    (Varient) => Varient.Dates
  );
  ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered_Dates.filter(
    (value, index, self) => self.indexOf(value) === index
  );

  const isFormValid = () => {
    return (
      Attendee?.BasicInfo?.First_Name &&
      Attendee?.BasicInfo?.Last_Name &&
      Attendee?.BasicInfo?.Gender &&
      Attendee?.BasicInfo?.Nationality &&
      Attendee?.BasicInfo?.DOB &&
      AttendeeEmail &&
      ParentEmail &&
      TeacherEmail &&
      Attendee?.BasicInfo?.ProgrammeTitle &&
      Attendee?.BasicInfo?.ProgrammeDate &&
      Attendee?.BasicInfo?.ProgrammeVarient
    );
  };

  //TODO Change
  //show form or redirect
  let redirectToScholarshipPage = true;

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      }}
    >
      <Container maxWidth="lg">
        {" "}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/InvestINBannerLogo.png`}
            alt="InvestIN Banner Logo"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </Box>
        <Typography
          variant="h5"
          component="h1"
          gutterBottom
          align="center"
          style={{ fontWeight: "bold", fontSize: "2.5rem" }}
        >
          InvestIN - Bursary Form
          {School.School_Name && School.School_Name !== ""
            ? " for " + School.School_Name
            : ""}
        </Typography>{" "}
        {redirectToScholarshipPage ? (
          <Typography
            variant="h2"
            component="h2"
            gutterBottom
            align="center"
            style={{ fontSize: "1.5rem" }}
          >
            Thank you for showing an interest in our weekend programme
            bursaries. Unfortunately, this initiative is now closed for the
            Spring term, with our programmes ending this month (March 2025).
            <br></br>
            <br></br>
            Applications will reopen in September 2025 for our next round of
            weekend opportunities, which begin in November. In the meantime, I'd
            like to direct your towards our Summer Scholarship Scheme.
            <br></br>
            <br></br>
            Full details about this initiative, including how to apply, are
            available on our website here:
            <br></br>
            <a href="https://www.investin.org/pages/scholarship-scheme">
              Scholarship Scheme – InvestIN Education
            </a>
            .<br></br>
            <br></br>
            Please note, places will be highly competitive, so we always
            recommend that students seek funding for a place if they want to
            guarantee their attendance this summer. If you have any questions,
            please don't hesitate to reach out to us on schools@investin.org
          </Typography>
        ) : (
          <>
            <br></br>
            <Typography
              variant="h5"
              component="h1"
              gutterBottom
              align="center"
              style={{ fontWeight: "bold", fontSize: "2rem" }}
            >
              {Object.keys(School).length !== 0 &&
              School.School_Name &&
              School.School_PS !== "Yes" ? (
                <>You are not yet a Partner School</>
              ) : (
                <>
                  {" "}
                  You have used {Number(Arr_ThisSchoolsBursaries.length)} places
                  and have {10 - Number(Arr_ThisSchoolsBursaries.length)}{" "}
                  remaining.
                </>
              )}

              <br></br>
            </Typography>
            <br></br>
            {IntroText}
            <>
              {isSubmitted ? (
                <Typography
                  variant="h5"
                  component="h1"
                  gutterBottom
                  align="center"
                  style={{ fontWeight: "bold", fontSize: "2rem" }}
                >
                  You may now close this page
                  <br></br>
                </Typography>
              ) : (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        key="First_Name"
                        name="First_Name"
                        label="Student First Name"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.BasicInfo && Attendee.BasicInfo["First_Name"]
                            ? Attendee.BasicInfo["First_Name"]
                            : ""
                        }
                        onChange={handleBasicInfoChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        key="Last_Name"
                        name="Last_Name"
                        label="Student Last Name"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.BasicInfo && Attendee.BasicInfo["Last_Name"]
                            ? Attendee.BasicInfo["Last_Name"]
                            : ""
                        }
                        onChange={handleBasicInfoChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        label="Student Gender"
                        name="Gender"
                        variant="outlined"
                        margin="normal"
                        value={
                          Attendee.BasicInfo && Attendee.BasicInfo["Gender"]
                            ? Attendee.BasicInfo["Gender"]
                            : ""
                        }
                        onChange={handleBasicInfoChange}
                        fullWidth
                        sx={{ marginBottom: "10px" }}
                        select
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <MenuItem key="" value=""></MenuItem>
                        <MenuItem key="M" value="M">
                          M
                        </MenuItem>{" "}
                        <MenuItem key="F" value="F">
                          F
                        </MenuItem>
                      </TextField>{" "}
                      <TextField
                        key="Nationality"
                        name="Nationality"
                        label="Student Nationality"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.BasicInfo &&
                          Attendee.BasicInfo["Nationality"]
                            ? Attendee.BasicInfo["Nationality"]
                            : ""
                        }
                        onChange={handleBasicInfoChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        key="DOB"
                        name="DOB"
                        label="Student DOB"
                        variant="outlined"
                        margin="normal"
                        type="date"
                        fullWidth
                        value={
                          Attendee.BasicInfo && Attendee.BasicInfo["DOB"]
                            ? Attendee.BasicInfo["DOB"]
                            : ""
                        }
                        onChange={handleBasicInfoChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true, // This will keep the label above the input field
                        }}
                      />
                      <TextField
                        key="AttendeeEmail"
                        name="AttendeeEmail"
                        label="Email Address of the Student"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={AttendeeEmail}
                        onChange={handleAttendeeEmailChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        key="ParentEmail"
                        name="ParentEmail"
                        label="Email Address of the Parent"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={ParentEmail}
                        onChange={handleParentEmailChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        key="TeacherEmail"
                        name="TeacherEmail"
                        label="Your (Teacher/School Employee) Email Address"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={TeacherEmail}
                        onChange={handleTeacherEmailChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <>
                        <TextField
                          key="ProgrammeTitle"
                          name="ProgrammeTitle"
                          label="Programme Title"
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          value={
                            Attendee.BasicInfo &&
                            Attendee.BasicInfo["ProgrammeTitle"]
                              ? Attendee.BasicInfo["ProgrammeTitle"]
                              : ""
                          }
                          onChange={handleProgrammeTitleChange}
                          InputProps={{
                            style: {
                              backgroundColor: "white",
                            },
                          }}
                          select
                        >
                          {ArrAllProgrammesFiltered_Titles.map((Title) => (
                            <MenuItem key={Title} value={Title}>
                              {Title}
                            </MenuItem>
                          ))}
                        </TextField>

                        <TextField
                          key="ProgrammeDate"
                          name="ProgrammeDate"
                          label="Programme Date"
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          value={
                            Attendee.BasicInfo &&
                            Attendee.BasicInfo["ProgrammeDate"]
                              ? Attendee.BasicInfo["ProgrammeDate"]
                              : ""
                          }
                          onChange={handleProgrammeDateChange}
                          InputProps={{
                            style: {
                              backgroundColor: "white",
                            },
                          }}
                          select
                        >
                          {ArrAllProgrammesFiltered_Dates.map((Date) => (
                            <MenuItem key={Date} value={Date}>
                              {Date}
                            </MenuItem>
                          ))}
                        </TextField>
                        <TextField
                          key="ProgrammeVarient"
                          name="ProgrammeVarient"
                          label="Programme Variant"
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          value={
                            Attendee.BasicInfo &&
                            Attendee.BasicInfo["ProgrammeVarient"]
                              ? Attendee.BasicInfo["ProgrammeVarient"]
                              : ""
                          }
                          onChange={handleBasicInfoChange}
                          InputProps={{
                            style: {
                              backgroundColor: "white",
                            },
                          }}
                          select
                        >
                          {ArrAllProgrammesFiltered_Varients.map((Varient) => (
                            <MenuItem key={Varient} value={Varient}>
                              {Varient}
                            </MenuItem>
                          ))}
                        </TextField>
                      </>
                      <Typography variant="h5" component="h1" gutterBottom>
                        Is there anything else we should know? Our team will
                        review any note added below.
                      </Typography>
                      <TextField
                        key="Note"
                        name="Note"
                        label="Note"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={Note}
                        onChange={handleNoteChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => handleSubmit(e)}
                        disabled={
                          isSubmitting ||
                          !isFormValid() ||
                          Number(Arr_ThisSchoolsBursaries.length) > 9 ||
                          School.School_PS !== "Yes"
                        }
                      >
                        {isFormValid ? (
                          <>Please Compelte All Fields To Submit</>
                        ) : isSubmitting ? (
                          "Submitting..."
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            </>
          </>
        )}
      </Container>
    </div>
  );
};

export default BursaryForm;
